import { render, staticRenderFns } from "./GuideTour.vue?vue&type=template&id=63cd94da&scoped=true"
import script from "./GuideTour.vue?vue&type=script&lang=js"
export * from "./GuideTour.vue?vue&type=script&lang=js"
import style0 from "./GuideTour.vue?vue&type=style&index=0&id=63cd94da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cd94da",
  null
  
)

export default component.exports